/** Default homepage hero slides — same content as backend HomepageHeroSlides + live site fallback. */
export const HOMEPAGE_HERO_SLIDES = [
  {
    hero_type: 'image',
    label_en: 'Home of the Intellectuals',
    label_ar: 'موطن المثقفين',
    title_en: 'Excellence in Education',
    title_ar: 'التميز في التعليم',
    subtitle_en: "Nurturing tomorrow's leaders with world-class curricula and compassionate care.",
    subtitle_ar: 'نرعى قادة الغد بمناهج عالمية ورعاية متكاملة.',
    image: '/slider/001.JPG',
    sort_order: 1,
    is_active: true,
  },
  {
    hero_type: 'image',
    label_en: 'Home of the Intellectuals',
    label_ar: 'موطن المثقفين',
    title_en: 'British & American Programs',
    title_ar: 'البرامج البريطانية والأمريكية',
    subtitle_en: 'Internationally recognized pathways from kindergarten through grade 12.',
    subtitle_ar: 'مسارات معترف بها دولياً من رياض الأطفال حتى الصف الثاني عشر.',
    image: '/slider/002.JPG',
    sort_order: 2,
    is_active: true,
  },
  {
    hero_type: 'image',
    label_en: 'Home of the Intellectuals',
    label_ar: 'موطن المثقفين',
    title_en: 'Beyond the Classroom',
    title_ar: 'ما وراء الفصل الدراسي',
    subtitle_en: 'Sports, arts, robotics, and community service that shape well-rounded graduates.',
    subtitle_ar: 'رياضة وفنون وروبوتiks وخدمة مجتمعية تُشكّل خريجين متكاملين.',
    image: '/slider/003.JPG',
    sort_order: 3,
    is_active: true,
  },
  {
    hero_type: 'image',
    label_en: 'Home of the Intellectuals',
    label_ar: 'موطن المثقفين',
    title_en: 'Join the Mayar Family',
    title_ar: 'انضم إلى عائلة ميار',
    subtitle_en: 'Discover a school where every child is known, valued, and inspired to achieve.',
    subtitle_ar: 'اكتشف مدرسة يُعرف فيها كل طفل ويُقدَّر ويُلهم للنجاح.',
    image: '/slider/004.JPG',
    sort_order: 4,
    is_active: true,
  },
]
